import React from "react";
import { Row, Col } from "react-bootstrap";
import Modalpopup from "../../../shared/components/Modalpopup";
import DefaultButton from "../../../shared/components/DefaultButton";

export default function WVGODetailsModal({ show, handleClose, wvgoDetails, loadingWVGO, syncingWVGO, onSync }) {
    return (
        <Modalpopup
            show={show}
            handleClose={handleClose}
            actionTitle={"WVGO Details"}
            size="xl"
        >
            {loadingWVGO ? (
                <div className="text-center p-4">
                    <i className="fas fa-spinner fa-spin fa-2x"></i>
                    <p className="mt-2">Loading WVGO details...</p>
                </div>
            ) : wvgoDetails && !wvgoDetails.success ? (
                <div>
                    {syncingWVGO ? (
                        <div
                            style={{
                                padding: '20px',
                                marginBottom: '15px',
                                backgroundColor: '#cfe2ff',
                                border: '1px solid #0d6efd',
                                borderRadius: '4px',
                                color: '#084298',
                                textAlign: 'center'
                            }}
                        >
                            <i className="fas fa-spinner fa-spin fa-2x" style={{ marginBottom: '10px' }}></i>
                            <p style={{ marginBottom: '0', fontSize: '1.1rem' }}>
                                <strong>Syncing user to WVGO...</strong>
                            </p>
                        </div>
                    ) : (
                        <div
                            style={{
                                padding: '20px',
                                marginBottom: '15px',
                                backgroundColor: '#f8d7da',
                                border: '1px solid #dc3545',
                                borderRadius: '4px',
                                color: '#721c24',
                                textAlign: 'center'
                            }}
                        >
                            <i className="fas fa-exclamation-circle" style={{ fontSize: '2rem', marginBottom: '10px' }}></i>
                            <p style={{ marginBottom: '0', fontSize: '1.1rem' }}>
                                <strong>{wvgoDetails?.msg || 'User not added in wVGO system'}</strong>
                            </p>
                        </div>
                    )}
                    <div className="col-md-12 text-end">
                        <DefaultButton
                            buttonClass={syncingWVGO ? "btn btn-primary me-2 disabled" : "btn btn-primary me-2"}
                            buttonTitle={syncingWVGO ? "Syncing..." : "Sync to WVGO"}
                            actionBlock={onSync}
                        />
                        <DefaultButton
                            buttonClass={"btn btn-secondary"}
                            buttonTitle={"Close"}
                            actionBlock={handleClose}
                        />
                    </div>
                </div>
            ) : wvgoDetails?.data ? (
                <div>
                    {/* Syncing Status Message */}
                    {syncingWVGO && (
                        <div
                            style={{
                                padding: '12px',
                                marginBottom: '15px',
                                backgroundColor: '#cfe2ff',
                                border: '1px solid #0d6efd',
                                borderRadius: '4px',
                                color: '#084298',
                                textAlign: 'center'
                            }}
                        >
                            <i className="fas fa-spinner fa-spin me-2"></i>
                            <strong>Syncing groups...</strong>
                        </div>
                    )}

                    {/* Sync Status Alert */}
                    {wvgoDetails.validation?.status === 'out_of_sync' && !syncingWVGO && (
                        <div
                            style={{
                                padding: '12px',
                                marginBottom: '15px',
                                backgroundColor: '#fff3cd',
                                border: '1px solid #ffc107',
                                borderRadius: '4px',
                                color: '#856404'
                            }}
                        >
                            <strong>⚠️ Out of Sync:</strong> {wvgoDetails.validation.message}
                        </div>
                    )}

                    {wvgoDetails.validation?.status === 'in_sync' && !syncingWVGO && (
                        <div
                            style={{
                                padding: '12px',
                                marginBottom: '15px',
                                backgroundColor: '#d4edda',
                                border: '1px solid #28a745',
                                borderRadius: '4px',
                                color: '#155724'
                            }}
                        >
                            <strong>✓ In Sync:</strong> All groups are synchronized with MDS data
                        </div>
                    )}

                    <Row>
                        <Col md={6}>
                            <dl className='row'>
                                <dt className='col-sm-5'>User ID</dt>
                                <dd className='col-sm-7'>{wvgoDetails.data.id || 'N/A'}</dd>
                            </dl>
                            <dl className='row'>
                                <dt className='col-sm-5'>Name</dt>
                                <dd className='col-sm-7'>
                                    {wvgoDetails.data.first_name} {wvgoDetails.data.last_name}
                                </dd>
                            </dl>
                            <dl className='row'>
                                <dt className='col-sm-5'>Email</dt>
                                <dd className='col-sm-7'>{wvgoDetails.data.email || 'N/A'}</dd>
                            </dl>
                            {/* <dl className='row'>
                                <dt className='col-sm-5'>Role</dt>
                                <dd className='col-sm-7'>
                                    <span style={{ textTransform: 'capitalize' }}>
                                        {wvgoDetails.data.role_id || 'N/A'}
                                    </span>
                                </dd>
                            </dl> */}
                        </Col>
                        <Col md={6}>
                            <dl className='row'>
                                <dt className='col-sm-5'>Created At</dt>
                                <dd className='col-sm-7'>
                                    {wvgoDetails.data.created_at
                                        ? new Date(wvgoDetails.data.created_at).toLocaleString()
                                        : 'N/A'}
                                </dd>
                            </dl>
                            <dl className='row'>
                                <dt className='col-sm-5'>Last Updated</dt>
                                <dd className='col-sm-7'>
                                    {wvgoDetails.data.updated_at
                                        ? new Date(wvgoDetails.data.updated_at).toLocaleString()
                                        : 'N/A'}
                                </dd>
                            </dl>
                            <dl className='row'>
                                <dt className='col-sm-5'>Last Login</dt>
                                <dd className='col-sm-7'>
                                    {wvgoDetails.data.last_login_at
                                        ? new Date(wvgoDetails.data.last_login_at).toLocaleString()
                                        : 'Never'}
                                </dd>
                            </dl>
                        </Col>
                    </Row>

                    {/* Current Groups */}
                    {wvgoDetails.data.groups && wvgoDetails.data.groups.length > 0 && (
                        <Row className="mt-3">
                            <Col md={12}>
                                <h6 style={{ borderBottom: '2px solid #0a7674', paddingBottom: '8px' }}>
                                    Current WVGO Groups ({wvgoDetails.data.groups.length})
                                </h6>
                                <div style={{ maxHeight: '200px', overflowY: 'auto', marginBottom: '10px' }}>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                        {wvgoDetails.data.groups.map((group, index) => (
                                            <span
                                                key={index}
                                                style={{
                                                    padding: '6px 12px',
                                                    backgroundColor: '#e7f3f3',
                                                    border: '1px solid #0a7674',
                                                    borderRadius: '4px',
                                                    fontSize: '0.85rem',
                                                    color: '#0a7674'
                                                }}
                                            >
                                                {group.name}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )}

                    {/* Group Differences */}
                    {wvgoDetails.validation?.differences && (
                        <Row className="mt-3">
                            <Col md={6}>
                                {wvgoDetails.validation.differences.missing_groups?.length > 0 && (
                                    <div>
                                        <h6 style={{ color: '#dc3545' }}>
                                            ⚠️ Missing Groups ({wvgoDetails.validation.differences.missing_groups.length})
                                        </h6>
                                        <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
                                            {wvgoDetails.validation.differences.missing_groups.map((group, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        padding: '6px 10px',
                                                        marginBottom: '5px',
                                                        backgroundColor: '#f8d7da',
                                                        border: '1px solid #dc3545',
                                                        borderRadius: '4px',
                                                        fontSize: '0.85rem',
                                                        color: '#721c24'
                                                    }}
                                                >
                                                    {group}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </Col>
                            <Col md={6}>
                                {wvgoDetails.validation.differences.extra_groups?.length > 0 && (
                                    <div>
                                        <h6 style={{ color: '#ffc107' }}>
                                            ⚠️ Extra Groups ({wvgoDetails.validation.differences.extra_groups.length})
                                        </h6>
                                        <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
                                            {wvgoDetails.validation.differences.extra_groups.map((group, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        padding: '6px 10px',
                                                        marginBottom: '5px',
                                                        backgroundColor: '#fff3cd',
                                                        border: '1px solid #ffc107',
                                                        borderRadius: '4px',
                                                        fontSize: '0.85rem',
                                                        color: '#856404'
                                                    }}
                                                >
                                                    {group}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    )}

                    {/* Buttons */}
                    <div className="col-md-12 mt-3 text-end">
                        {wvgoDetails.validation?.status === 'out_of_sync' && (
                            <DefaultButton
                                buttonClass={syncingWVGO ? "btn btn-primary me-2 disabled" : "btn btn-primary me-2"}
                                buttonTitle={syncingWVGO ? "Syncing..." : "Sync Groups"}
                                actionBlock={onSync}
                            />
                        )}
                        <DefaultButton
                            buttonClass={"btn btn-secondary"}
                            buttonTitle={"Close"}
                            actionBlock={handleClose}
                        />
                    </div>
                </div>
            ) : (
                <div className="text-center p-4">
                    <p>No data available</p>
                </div>
            )}
        </Modalpopup>
    );
}
